import React, { FC } from 'react';
import { graphql } from 'gatsby';

import { useUpdateOTLds } from '@phx-husky/use-update-ot-lds';

import Layout from 'layout/Layout';
import Container from 'layout/Container';
import Title from 'common/Title';
import BreadCrumbs from 'common/BreadCrumbs';
import DangerouslySetInnerHtml from 'common/DangerouslySetInnerHtml';

import { schemaService } from 'utils/schemaService';

import { IPropsLdsPage } from './models';

import './LdsPage.scss';

const LdsPage: FC<IPropsLdsPage> = ({ data: { pageData }, pageContext: { breadcrumbs, link } }) => {
  const { seo, defaultCompositions } = pageData;

  const { body, businessId, versionId, platform } = pageData?.ldsInfo?.[0]?.properties;

  const { updatedLdsContent, isCheckingLdsVersion } = useUpdateOTLds({
    baseUrl: process.env.GATSBY_LDS_BASE_URL as string,
    businessId,
    versionId,
    platform,
  });

  return (
    <Layout
      seo={seo}
      defaultCompositions={defaultCompositions}
      additionalStructuredSchemas={[schemaService.schemaTypes.BreadcrumbList]}
      dynamicStructuredSchemaValues={{ pageUrl: link, breadcrumbs }}
    >
      <div data-test="LdsPage" className="lds-page">
        <Container fluid>
          <BreadCrumbs breadcrumbs={breadcrumbs} />

          <Title dataTestAttr="LdsPageTitle" Tag="h1" className="lds-page__title">
            {pageData.title}
          </Title>

          {!isCheckingLdsVersion && (
            <DangerouslySetInnerHtml
              html={updatedLdsContent ?? body}
              className="lds-page__content"
            />
          )}
        </Container>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query ($link: String!, $lang: String!) {
    pageData: lds(link: { eq: $link }, lang: { eq: $lang }) {
      seo {
        ...FragmentSeo
      }
      defaultCompositions {
        ...FragmentDefaultCompositions
      }
      title
      ldsInfo {
        properties {
          body
          businessId
          platform
          versionId
        }
      }
    }
  }
`;

export default LdsPage;
